// extracted by mini-css-extract-plugin
export default {"colorPrimaryGrey":"#5C6770","agentusLabel":"Et6YW7ZVyNxocyIBsc_j"};